import { create } from 'zustand';
import { BulletinResum } from '../types';

interface FiltreBulletins {
  mois: number;
  annee: number;
  idEmploye?: string;
  statut?: string;
  idProjet?: string;
  sansProjet?: boolean;
}

interface BulletinsStore {
  bulletinSelectionne: BulletinResum | null;
  filtres: FiltreBulletins;
  jobEnCours: { jobId: string; progression: number; total: number; erreurs: number } | null;

  setBulletinSelectionne: (b: BulletinResum | null) => void;
  setFiltres: (f: Partial<FiltreBulletins>) => void;
  setJobEnCours: (job: BulletinsStore['jobEnCours']) => void;
}

const now = new Date();

export const useBulletinsStore = create<BulletinsStore>((set) => ({
  bulletinSelectionne: null,
  filtres: { mois: now.getMonth() + 1, annee: now.getFullYear() },
  jobEnCours: null,

  setBulletinSelectionne: (b) => set({ bulletinSelectionne: b }),
  setFiltres: (f) => set(s => ({ filtres: { ...s.filtres, ...f } })),
  setJobEnCours: (job) => set({ jobEnCours: job }),
}));
